// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__1eFJi","Div":"CustomFadeBox_Div__2S3_j","LargeDiv":"CustomFadeBox_LargeDiv__2xnRM"};